import { render, staticRenderFns } from "./ApprovalOwnerModal.vue?vue&type=template&id=3131dceb&"
import script from "./ApprovalOwnerModal.vue?vue&type=script&lang=js&"
export * from "./ApprovalOwnerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports